import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import DocumentForm from "./DocumentForm";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const DocumentFormView = ({props, ...rest}) => {
  const classes = useStyles();
  const editMode = rest.kmaction === "edit";

  let pageTitle = rest.kmaction === "new" ? "Nowy dokument" : "Edycja dokumentu";

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
      { pageTitle }
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <DocumentForm editMode={editMode}/>
        </Box>
      </Container>
    </Page>
  );
};

export default DocumentFormView;
